export const isObjectEmpty = <O extends Record<string, unknown>>(object: O) =>
  Object.keys(object).length === 0;
